import { DataSourceSettingsDto, MutateWidgetPayload, VariableDto } from '@thingslog/repositories';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetSettingsForm } from '../../forms';
import { DashboardSidebarWidgetCard } from './DashboardSidebarWidgetCard';

interface Props {
  widgetId: string;
  dataSources: DataSourceSettingsDto[];
  variables: VariableDto[];
  isPersisting: boolean;
  onPersistNewWidget: (
    payload: MutateWidgetPayload,
    callbacks?: { onSuccess?: () => void }
  ) => void;
  onClose: (widgetId: string) => void;
  onStartTour: () => void;
}

export const DashboardSidebarDashboardWidgetAddWidget: FC<Props> = ({
  widgetId,
  dataSources,
  variables,
  isPersisting,
  onPersistNewWidget,
  onClose,
  onStartTour,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DashboardSidebarWidgetCard
      title={t('dashboard_add_widget', 'Add Widget')}
      widgetId={widgetId}
      expandable
      onClose={onClose}
      onStartTour={onStartTour}
    >
      <WidgetSettingsForm
        type="create"
        dataSources={dataSources}
        variables={variables}
        disabled={isPersisting}
        onSubmit={(payload: MutateWidgetPayload): void => {
          onPersistNewWidget(payload, { onSuccess: () => onClose(widgetId) });
        }}
        onCancel={(): void => {
          onClose(widgetId);
        }}
      />
    </DashboardSidebarWidgetCard>
  );
};
